import { render, staticRenderFns } from "./TheSharer.vue?vue&type=template&id=e97ec07c&"
import script from "./TheSharer.vue?vue&type=script&lang=ts&"
export * from "./TheSharer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports